<template>
  <NewTask
    taskType="compare_doc"
    :docList="['Invoice', 'Packing List', 'Waybill']"
  >
  </NewTask>
</template>

<script>
import axios from 'axios'
import NewTask from '@/components/NewTask.vue';

export default {
  components: {
    NewTask
  },
}
</script>
